import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    avatar: {
      backgroundColor: theme.gray100,
      border: "1px solid rgba(229, 226, 241, 0.1)",
      borderRadius: "4px",
      color: theme.gray800,
      fontSize: "16px",
      fontWeight: 500,
      height: "48px",
      lineHeight: "19px",
      width: "49px",
    },
    userData: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(8),
      padding: 0,
    },
    mainDataContainer: {
      alignItems: "center",
      background: theme.gray50,
      borderRadius: "8px 8px 0 0",
      boxShadow: `0px 1px 0px ${theme.gray100}`,
      display: "flex",
      gap: theme.spacing(8),
      padding: theme.spacing(6, 8),
    },
    userHeader: {
      color: theme.gray800,
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    smallText: {
      color: theme.gray800,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    header: {
      color: theme.gray800,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "22px",
      margin: theme.spacing(12, 0, 8, 0),
      textTransform: "uppercase",
      textWrap: "nowrap",
      display: "flex",
      gap: theme.spacing(4),
      alignItems: "center",
    },
    walletDetails: {
      padding: theme.spacing(4, 8),
    },
    walletName: {
      fontSize: 14,
      display: "flex",
      justifyContent: "space-between",
      "& > span": {
        color: theme.gray500,
      },
    },
    walletActivePoints: {
      alignItems: "baseline",
      display: "flex",
      fontSize: 18,
      fontWeight: 500,
      lineHeight: "29px",
      "& > span": {
        color: theme.gray500,
        fontSize: 14,
        fontWeight: 400,
        marginLeft: theme.spacing(5),
      },
    },
    hiddenOverflow: {
      overflow: "hidden",
    },
    icon: {
      color: theme.gray500,
      height: "16px",
      width: "16px",
    },
    tier: {
      backgroundColor: theme.primary50,
      borderRadius: "32px",
      color: theme.primary800,
      display: "flex",
      fontSize: "12px",
      gap: theme.spacing(4),
      lineHeight: "16px",
      padding: theme.spacing(2, 6),
    },
    tierIcon: {
      color: theme.primary500,
      height: "16px",
      width: "16px",
    },
    headerContainer: {
      alignItems: "start",
      display: "flex",
      gap: theme.spacing(4),
      height: "100%",
    },
    divider: {
      borderBottom: `1px solid ${theme.gray200}`,
      width: "100%",
    },
    tiersHeaderWrapper: {
      alignItems: "center",
      display: "flex",
      gap: theme.spacing(12),
      justifyContent: "space-between",
      marginBottom: theme.spacing(4),
    },
    titleSection: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      "& > button": {
        marginBottom: theme.spacing(4),
      },
    },
    positionContainer: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(4),
    },
    position: {
      fontSize: 14,
      lineHeight: "20px",
    },
    bottomSpacing: {
      marginBottom: theme.spacing(8),
    },
  }),
);
